import styled from "styled-components";

export const Container = styled.div`
  background: #1D2C3B;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;

  .error-login{
      color: var(--white);
      font-size: 0.875rem;
      margin-top: -0.5rem;
      margin-bottom: 0.5rem;
    }

`;

export const Content = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

export const LoginCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 400px;

  img {
    width: 80px;
    height: 80px;
    margin-bottom: 1.5rem;
  }

  form {
    width: 100%;
    max-width: 400px;
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
  }

  @media (max-width: 768px) {
    min-width: 90%;
    padding: 2rem 2rem;
  }
`;

export const Title = styled.h1`
  color: var(--white);
  font-size: 1.5rem;
  font-weight: 400;
  margin-bottom: 2rem;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 1.25rem;
  }
`;

export const IconInput = styled.div`
  position: relative;
  width: 100%;
  margin-bottom: 0.5rem;

  .eye-icon {
    position: absolute;
    right: 0.1rem;
    top: 50%;
    transform: translateY(-50%);
    font-size: 1.15rem;
    height: 30px;
    width: 30px;
}


  .user-icon {
    position: absolute;
    right: 1rem;
    top: 50%;
    transform: translateY(-50%);
    font-size: 1.15rem;
    height: 30px;
    width: 30px;
  }
    
`;

export const Input = styled.input`
  width: 100%;
  max-width: 400px;
  padding: 1rem;
  border-radius: 2px;
  background-color: var(--white);
  font-size: 1rem;
  color: var(--text-gray);

  &::placeholder {
    color: var(--clear-gray);
  }

  &:focus {
    box-shadow: 0 0 0 2px var(--blue);
  }

  @media (max-width: 768px) {
    
    font-size: 1rem;
    padding: 1rem;
  }
`;

export const IconEye = styled.button`
  position: absolute;
  right: 1rem;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  color: var(--gray);
  font-size: 1.15rem;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.25rem;
  transition: color 0.2s;

  &:hover {
    color: var(--text-gray);
  }

  &:focus {
    outline-offset: 2px;
    border-radius: 2px;
  }
`;

export const ButtonWrapper = styled.div`
  margin-top: 1rem;

  button {
    background: #00467E;
    width: 100%;
    padding: 0.875rem;
    font-size: 1rem;
    font-weight: 500;
    letter-spacing: 0.5px;
    border-radius: 2px;

    &:hover {
      background: #2c648b;
    }

    &:disabled {
      background: #cccccc;
      cursor: not-allowed;
    }
  }
`;
